import { render, staticRenderFns } from "./ArticleLicence.vue?vue&type=template&id=dbca316c&"
import script from "./ArticleLicence.vue?vue&type=script&lang=ts&"
export * from "./ArticleLicence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports